import { BryntumSplitter } from "@bryntum/schedulerpro-react";
import React, { useEffect, useRef } from "react";
import { Store } from "@bryntum/schedulerpro";
import { Resource } from "../../bryntum-lib/models/Resource";
import { Task } from "../../bryntum-lib/models/Task";
import BryntumSchedulerWrapper from "../components/BryntumScheduler.jsx";
import BryntumGridWrapper from "../components/BryntumGrid.jsx";
import { getDummyBoardData } from "../../network/network.jsx";
import ViewSpecificHeader from "../components/appHeader/ViewSpecificHeader.jsx";

const selectionMode = {
  row: false,
  multiSelect: false
}

const PreviewPage = () => {
  const scheduleRef = useRef();
  const taskGridRef = useRef();

  useEffect(() => {
    getDummyBoardData()
      .then(({ data: { resources, tasks } }) => {
        if (scheduleRef.current?.instance) {
          scheduleRef.current.instance.store = new Store({ modelClass: Resource, data: resources?.rows || [] });
        }
        if (taskGridRef.current?.instance) {
          taskGridRef.current.instance.store = new Store({ modelClass: Task, data: tasks?.rows || [] });
        }
      }).catch((e) => {
        console.error('err', e)
      });
  }, []);

  return (
    <>
      <ViewSpecificHeader />
      <div
        className="main-grid-view main-view-resources"
        style={{ display: "flex", width: "100%", height: "100%" }}
      >
        <BryntumSchedulerWrapper
          ref={(ref) => scheduleRef.current = ref}
          flex="1 1 75%"
          readOnly
          disabled
          selectionMode={selectionMode}
          data={[]}
        />
        <BryntumSplitter />
        <BryntumGridWrapper
          ref={(ref) => taskGridRef.current = ref}
          flex="1 1 25%"
          readOnly
          disabled
          selectionMode={selectionMode}
          data={[]}
        />
      </div>
    </>
  );
};

export default PreviewPage;
